import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import instagram from "asset/image/instagram.png";
import twitter from "asset/image/twitter.png";
import Youtube from "asset/image/youtube.png";
import facebook from "asset/image/facebook.png";
import { useHistory, Link } from "react-router-dom";
import { SiWhatsapp } from "react-icons/si";
import {
  saveSelectedCategory,
  saveSelectedType,
} from "features/homepage/homeDataSlice";
import { BsFillTelephoneFill } from "react-icons/bs";

import {
  StyledFooterContainer,
  StyledFooterList,
  StyledFooterListItem,
  StyledFooterListAnchor,
  StyledFooterHeadingItem,
  StyledFooterImage,
  StyledFooter1Image,
  StyledBootmFooterContainer,
  StyledMegaFooter,
  StyledMegaFootertwo,
  Styledwhite,
  Styledborder,
  StyledFooterImage1,
} from "./footer.styles";
import "./Footer.css";
import { Row, Col, Container } from "react-bootstrap";
import IOS from "asset/image/IosDownload.png";
import Android from "asset/image/AnaroidDownload.png";
import CustomerService from "component/DealerLocator/CustomerService";

const INTERNATION_CAT_ID = 112;
// const kitchensinks = "kitchen-sinks";
// const germfree = "germ-free";

const Footer = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.home);
  const [catnames, setCatNames] = useState([]);
  const selectCategoryType = (catId, typeId) => {
    // set catId
    dispatch(saveSelectedCategory(catId));
    dispatch(saveSelectedType(typeId));
    history.push("/products/" + catId + "/" + typeId);
  };
  const handleRedirects = (path) => {
    window.open(path);
  };
  // useEffect(() => {
  // 	let arraycat = [];
  // 	categories &&
  // 		categories.children_data.forEach((name) => arraycat.push(name));
  // 	setCatNames(arraycat);
  // }, [categories]);
  // console.log('....catname', catnames);
  return (
    <>
      <StyledFooterContainer>
        <CustomerService />
      </StyledFooterContainer>
      <div className="footer">
        <StyledFooterContainer>
          <div className="container">
            <div className="row">
              {categories &&
                categories.children_data &&
                categories.children_data.map(
                  (cat, index) =>
                    cat.children_data.length > 0 &&
                    cat.id !== INTERNATION_CAT_ID &&
                    (cat.name === "Johnson International" ||
                    cat.url_key === "bath-cabinets" ? (
                      <div key={index} className="col-md-2 col-12">
                        <StyledFooterList>
                          <StyledFooterHeadingItem>
                            <div>
                              <b>{cat.name}</b>
                              <Styledborder />
                            </div>
                          </StyledFooterHeadingItem>
                          {cat &&
                            cat.children_data &&
                            cat.children_data.map(
                              (item, index) =>
                                item.level === 3 &&
                                index < 8 && (
                                  <StyledFooterListItem key={index}>
                                    <StyledFooterListAnchor>
                                      <span
                                        onClick={() =>
                                          selectCategoryType(
                                            cat.url_key,
                                            item.url_key
                                          )
                                        }
                                      >
                                        {" "}
                                        {item.name}
                                      </span>
                                    </StyledFooterListAnchor>
                                  </StyledFooterListItem>
                                )
                            )}
                        </StyledFooterList>
                      </div>
                    ) : (
                      <div key={index} className="col-md-2 col-12">
                        <StyledFooterList>
                          <StyledFooterHeadingItem>
                            <div>
                              <b>{cat.name}</b>
                              <Styledborder />
                            </div>
                          </StyledFooterHeadingItem>
                          {cat &&
                            cat.children_data &&
                            cat.children_data.map(
                              (item, index) =>
                                item.level === 3 &&
                                index <= 8 && (
                                  <StyledFooterListItem key={index}>
                                    <StyledFooterListAnchor>
                                      <span
                                        onClick={() =>
                                          selectCategoryType(
                                            cat.url_key,
                                            item.url_key
                                          )
                                        }
                                      >
                                        {" "}
                                        {item.name}
                                      </span>
                                    </StyledFooterListAnchor>
                                  </StyledFooterListItem>
                                )
                            )}
                        </StyledFooterList>
                      </div>
                    ))
                )}
              {/* 
					<div className='col-md-2 col-12'>
						<br />
						<span> </span>
						<StyledFooterList>
							<StyledFooterHeadingItem>
								{' '}
								<b> </b>{' '}
							</StyledFooterHeadingItem>
							<StyledFooterListItem>
								<StyledFooterListAnchor>
									<Link
										to={'/products/johnson-international'}
										className='side_link'
									>
										Johnson International
									</Link>
								</StyledFooterListAnchor>
							</StyledFooterListItem>
							<StyledFooterListItem>
								<StyledFooterListAnchor>
									<Link to={'/products/germ-free'} className='side_link'>
										Germ Free
									</Link>
								</StyledFooterListAnchor>
							</StyledFooterListItem>
							<StyledFooterListItem>
								<StyledFooterListAnchor>
									<Link to={'/about-us'} className='side_link'>
										{' '}
										About US
									</Link>
								</StyledFooterListAnchor>
							</StyledFooterListItem>
							<StyledFooterListItem>
								<StyledFooterListAnchor>
									<Link to={'/catalogue'} className='side_link'>
										Catalogue
									</Link>
								</StyledFooterListAnchor>
							</StyledFooterListItem>
							<StyledFooterListItem>
								<StyledFooterListAnchor>
									<Link to={'/locate/corporate-office'} className='side_link'>
										Contact
									</Link>
								</StyledFooterListAnchor>
							</StyledFooterListItem>
						</StyledFooterList>
					</div> */}
              <div className=" footer-downloads col-md-2">
                <StyledFooterList>
                  <StyledFooterHeadingItem>
                    {" "}
                    <b> Download App </b> <br />
                    <Styledborder />
                  </StyledFooterHeadingItem>
                  <Row>
                    <Col>
                      <StyledFooterImage>
                        <StyledFooter1Image>
                          <img
                            src={IOS}
                            onClick={() =>
                              handleRedirects(
                                "https://apps.apple.com/in/app/johnson-bathroom/id6444789043"
                              )
                            }
                            alt=""
                            width={129}
                            height={45}
                            loading="lazy"
                          />
                        </StyledFooter1Image>
                        <StyledFooter1Image>
                          <img
                            src={Android}
                            alt=""
                            onClick={() =>
                              handleRedirects(
                                "https://play.google.com/store/apps/details?id=com.johnson.johnsonbathroom"
                              )
                            }
                            width={129}
                            height={45}
                            loading="lazy"
                          />
                        </StyledFooter1Image>
                      </StyledFooterImage>
                    </Col>
                  </Row>
                </StyledFooterList>
              </div>
              <div className=" footer-social-links col-md-2">
                <StyledFooterHeadingItem>
                  {" "}
                  <div>
                    <b> Follow Us </b> <br />
                    <Styledborder />
                  </div>
                </StyledFooterHeadingItem>
                <Styledwhite>
                  <StyledFooterImage1>
                    <StyledFooterImage1>
                      <img
                        src={instagram}
                        onClick={() =>
                          handleRedirects(
                            "https://www.instagram.com/hrjohnson_india/"
                          )
                        }
                        alt=""
                        width={32}
                        height={32}
                        loading="lazy"
                      />
                    </StyledFooterImage1>
                    <StyledFooterImage1>
                      <img
                        src={twitter}
                        onClick={() =>
                          handleRedirects("https://twitter.com/Hrjohnsonindia")
                        }
                        alt=""
                        width={32}
                        height={32}
                        loading="lazy"
                      />
                    </StyledFooterImage1>
                    <StyledFooterImage1>
                      <img
                        src={Youtube}
                        onClick={() =>
                          handleRedirects(
                            "https://www.youtube.com/user/Hrjohnsonindia1"
                          )
                        }
                        alt=""
                        width={32}
                        height={32}
                        loading="lazy"
                      />
                    </StyledFooterImage1>
                    <StyledFooterImage1>
                      <img
                        src={facebook}
                        onClick={() =>
                          handleRedirects("https://www.facebook.com/HRJIndia")
                        }
                        alt=""
                        width={32}
                        height={32}
                        loading="lazy"
                      />
                    </StyledFooterImage1>
                  </StyledFooterImage1>
                </Styledwhite>
              </div>
              <div className="footer-customer-care col-md-2">
                <StyledFooterHeadingItem>
                  {" "}
                  <div>
                    <b>Customer Care</b> <br />
                    <Styledborder />
                  </div>
                </StyledFooterHeadingItem>
                <span className="letter-space-footer">
                  <SiWhatsapp className="whatup-icon-footer spaceicon" />
                  <a href={"https://api.whatsapp.com/send?phone=8451057484"}>
                    {" "}
                    +91-8451057484
                  </a>
                </span>
                <br />
                <span className="letter-space-footer">
                  <BsFillTelephoneFill className="whatup-icon-footer spaceicon" />
                  <a href="tel:+18002107484"> 1800 210 7484 </a>
                </span>
              </div>
            </div>
          </div>
        </StyledFooterContainer>
        <StyledBootmFooterContainer>
          <Container>
            <Row>
              <Col sm={6}>
                <StyledMegaFooter>
                  H & R JOHNSON(INDIA).All Right Reserved{" "}
                </StyledMegaFooter>
              </Col>
              <Col sm={6} className="text-center">
                <StyledMegaFootertwo>
                  <Link className="footer-links" to="/termofuse">
                    Term of Use
                  </Link>
                  <Styledwhite> | </Styledwhite>{" "}
                  <Link className="footer-links" to="/privacy/policy">
                    {" "}
                    Privacy Policy
                  </Link>
                  <Styledwhite> | </Styledwhite>{" "}
                  <Link to="/disclaimer" className="footer-links">
                    {" "}
                    Disclaimer
                  </Link>
                </StyledMegaFootertwo>
              </Col>
            </Row>
          </Container>
        </StyledBootmFooterContainer>
      </div>
    </>
  );
};

export default Footer;
